import { AxiosInstance } from 'axios';
import { TrialBalanceReportRequestModel } from './models/TrialBalanceReportRequestModel';
import * as TrialBalanceReportService from './services';

export type TrialBalanceReportServiceType = {
  exportPDF: (payload: TrialBalanceReportRequestModel) => Promise<void>;
};

export const initTrialBalanceReportService = (
  axios: AxiosInstance
): TrialBalanceReportServiceType => ({
  exportPDF: payload => TrialBalanceReportService.exportPDF(axios)(payload),
});
